module.exports = __webpack_public_path__ + "static/img/zf_banner.1b58ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/zf_banner.png
// module id = LB0D
// module chunks = 1